<template>
  <div class="carousel" :style="!isMobile || 'height:auto;'">
    <!-- <Carousel :height="`${bodyWidth * (1070 / 1915)}px`" direction="vertical" :autoplay="true" arrow="never">
      <CarouselItem v-for="item in 2" :key="item">
        <img src="@/images/home-carousel-01.jpg" alt="carousel" />
      </CarouselItem>
    </Carousel> -->
    <div class="page page_01" :style="!isMobile || 'height:auto;'">
      <img
        src="https://mp-lelight.oss-cn-guangzhou.aliyuncs.com/pic/ic_home_top_bg.png"
        alt="carousel"
      />
    </div>
  </div>
</template>

<script>
// import { Carousel, CarouselItem } from 'element-ui';
import { _isMobile } from "@/utils/config";

export default {
  name: "carousel",
  // 与父组件通信
  props: {},
  // 组件
  components: {
    /*Carousel, CarouselItem*/
  },
  // 数据
  data() {
    return {
      bodyWidth: 0,
      isMobile: _isMobile(),
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {
    this.bodyWidth = document.body.clientWidth;
  },
  // 方法
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "./index.less";
</style>
